import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.less']
})
export class LoadingComponent implements OnInit {
  isLoading: boolean=true;
  constructor(public loadingService: LoadingService) {}
 
  ngOnInit(): void {
    this.isLoading = this.loadingService.getLoadingState();
  }

}
